<template>
  <div class="relation-info-item">
    <h2 class="relation-info-tit">
      {{ $t('message["408"]') }}
    </h2>
    <a-form
      layout="inline"
      :form="form"
      class="demo-form-inline"
      @submit.prevent="submitHandle"
    >
      <div v-if="datasReady && developDatasReady">
        <div class="relation-list">
          <relation-item
            v-for="(item,index) in currentData"
            :key="item.id || item._id"
            :index="index"
            :item="item"
          />
          <div
            class="add-rule"
            @click="addRuleItem"
          >
            <a
              href="javascript:;"
            >{{ $t('message["1195"]') }}</a>
          </div>
        </div>
        <div class="footer-wrap">
          <div
            ref="footer"
            class="footer"
          >
            <a-button
              type="primary"
              html-type="submit"
              :loading="submitting"
            >
              {{ $t('message["21"]') }}
            </a-button>
            <!-- <a-button @click="handleCancel">
              取消
            </a-button> -->
          </div>
        </div>
      </div>
      <div
        v-else
        class="loading"
      >
        <a-spin tip="loading" />
      </div>
    </a-form>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import { mapGetters, mapActions, mapState } from 'vuex'
import RelationItem from './RelationItem'
export default {
  components: {
    RelationItem
  },
  data () {
    return {
      submitting: false
    }
  },
  computed: {
    ...mapGetters('config/relation', ['currentData']),
    ...mapState('config/relation', ['treeItemObj', 'datasReady', 'developDatasReady'])
  },
  watch: {
    datasReady (val) {
      if (val) {
        // this.setFooterStyle()
      }
    }
  },
  created () {
    this.form = this.$form.createForm(this)
    // this.setFooterStyle()
    // window.addEventListener('resize', this.setFooterStyle)
    // document.addEventListener('scroll', this.setFooterStyle)
    if (this.developDatasReady) {
      document.title = this.$t('message["1365"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
    }
  },
  methods: {
    ...mapActions('config/relation', ['subRule']),
    submitHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          let obj = {}
          const { currentData } = this
          if (Object.keys(currentData).length > 0) {
            obj = Object.assign({}, currentData)
          } else {
            if (Object.keys(this.treeItemObj).length > 1) {
              obj = Object.assign(this.treeItemObj, { mark: 1 })
            } else {
              obj = Object.assign({}, this.treeItemObj, { mark: 1, roleid: 0, groupid: 0 })
            }
          }
          this.submitting = true
          const chain = await this.subRule()
          chain.params(obj)
            .onSuccess(async () => {
              this.$message.success(`${this.$t('message["23"]')}！`)
              setTimeout(() => {
                this.$router.push({ name: 'configRelationList' })
              }, 1000)
            })
            .onNetSuccess((res) => {
              this.submitting = false
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    addRuleItem () {
      const { currentData } = this
      if (currentData.length) {
        const cloneData = cloneDeep(currentData[0])
        currentData.push(cloneData)
        const obj = currentData[currentData.length - 1]
        this.$set(obj, 'relaterule', {})
        this.$delete(obj, 'id')
        this.$set(obj, '_id', Math.random())
      } else {
        let obj = {
          fieldkey: 'website',
          relaterule: {},
          _id: Math.random()
        }
        obj = Object.assign(obj, this.treeItemObj)
        currentData.push(obj)
      }
    }
  }
}
</script>
<style lang="scss" scoped >
  .relation-info-item {
    width: 712px;
    margin-left: 40px;
    float: left;
   .footer-wrap {
    height: 64px;
    margin-top: 32px;

  }
  // .footer {
  //   position: fixed;
  //   bottom: 0;
  //   left: 0;
  //   z-index: 999;
  //   height: 64px;
  //   margin-left: -40px;
  //   padding: 16px 80px;
  //   background-color: #fff;
  //   border-top: solid 1px $gray4;
  // }
    .relation-info-tit {
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      font-weight: 600;
      border-bottom: 1px solid #ebebeb
    }
    .add-rule {
      border: 1px dashed #d6d6d6;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      margin-top: 24px;
    }
  }
</style>
